import axios from "axios";
import { getHeaders } from "./headers";
import { BASE_URL } from "../../constants/general";

export const backToMarketing = async () => {
    try {
        const response = await axios.post(`${BASE_URL}/v6/return_to_marketing`, null, {
            headers: getHeaders(),
        });

        const { status } = response;

        return status;
    } catch (error) {
        console.log(error);
    }
};
